<agr-dialog [data]="data" (cancel)="cancel()" class="return-packaging-search-dialog" data-test="return-packaging-search-dialog">
  <div>
    <p class="spacing--margin-half-vertical">
      {{ 'product.return-empty-search.description' | translate }}
    </p>
    <div class="flex">
      <div>
        <p class="spacing--margin-none-vertical text--label">
          {{ 'product.return-search.product-count' | translate }}
        </p>
        <p class="spacing--margin-none-vertical">
          {{ productCount | async }}
        </p>
      </div>
    </div>
  </div>
  <div class="empty-products-section">
    <h3>{{ 'product.return-empty-search.dialog-title' | translate }}</h3>
    <mat-form-field appearance="fill" class="return-packaging-search-dialog__input" data-test="return-packaging-search-dialog__input">
      <mat-label>{{ 'product.return-empty-search.search-label' | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        #searchBar
        type="text"
        matInput
        [placeholder]="'product.return-search.select' | translate"
        [formControl]="searchBarControl"
        (keydown.enter)="$event.preventDefault()"
        autocomplete="on"
      />
      <button *ngIf="searchBarControl.value" matSuffix mat-icon-button (click)="clearSearchBar()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="return-packaging-search-dialog__table spacing--margin-bottom">
    <agr-table-v2 [dataSource]="dataSource">
      <!-- Templates below are empty on purpose -->
      <ng-container *agrTableFiltersWrapper></ng-container>
      <ng-container *agrTableTopBar></ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'product.return-empty-search.table.product' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'product.return-empty-search.table.product' | translate" *matCellDef="let row">
          <div class="flex--column flex--justify-center" [class]="'return-packaging-search-dialog__multi-line-column'">
            <span class="text--default">{{ row.title }}</span>
            <span class="text--label">
              {{ 'product.search.table.article-number' | translate: { articleNumber: row.externalId } }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'product.return-empty-search.table.quantity' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'product.return-empty-search.table.quantity' | translate" *matCellDef="let row; let i = index">
          <div *ngIf="quantityForms as formGroup" class="column-quantity">
            <ng-container>
              <mat-form-field
                floatLabel="auto"
                subscriptSizing="dynamic"
                appearance="fill"
                (click)="$event.stopPropagation()"
                class="full-width-field spacing--padding-right mat-form-field__no-spacing column-quantity__form-field"
              >
                <mat-label>{{ 'app.favorites.quantity' | translate }}</mat-label>
                <input matInput agrNumber [step]="1" [min]="1" [max]="1000" [formControl]="$any(formGroup.at(i))" />
                <span *ngIf="row.unit" matIconSuffix data-test="table-desktop__input-number-suffix" [attr.data-translate-key]="row.unit">
                  {{ 'unit.' + row.unit | translate }}
                </span>
              </mat-form-field>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="addToCart">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div class="flex--row flex--align-end flex--justify-center return-packaging-search-dialog__add-to-cart-wrapper">
            <ng-container *ngIf="quantityForms.at(i) as quantityFormControl">
              <button
                mat-flat-button
                color="primary"
                class="text--small return-packaging-search-dialog__add-to-cart"
                data-test="return-packaging-search-dialog__add-to-cart"
                (click)="addReturnLineToCart(row, i)"
                [disabled]="quantityFormControl.invalid"
              >
                <mat-icon class="return-packaging-search-dialog__add-shopping-icon">add_shopping_cart</mat-icon>
                {{ 'product.return-empty-search.table.add-to-cart' | translate }}
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <tr *matNoDataRow>
        <td class="text--center" [attr.colspan]="tableColumns.length">
          <agr-notification-empty
            data-test="return-table-data__empty"
            [isEmpty]="true"
            [emptyTitle]="'product.return-search.table.empty-title' | translate"
            [emptyDescription]=""
            [emptyImage]="'/assets/images/no-items-3.png'"
            class="spacing--margin-top"
          ></agr-notification-empty>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let myRowData; columns: tableColumns"></tr>
    </agr-table-v2>
  </div>
</agr-dialog>
